import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative py-32 md:py-40 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.18),transparent_60%)]" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div className="text-xs tracking-[0.3em] uppercase font-bold text-gold mb-6">Closing Time</div>
        <h2 className="font-heading text-5xl md:text-7xl font-light text-white tracking-tighter leading-[1.05]">
          Your business deserves capital.<br />
          <span className="text-gold">Get it today.</span>
        </h2>
        <p className="mt-8 text-white/60 text-lg md:text-xl max-w-2xl mx-auto">
          Same-day funding available. No bank runaround. Real specialists. Real money.
          One short form between you and the capital you need.
        </p>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
          <a
            href="#apply"
            data-testid="final-cta-primary"
            className="group inline-flex items-center gap-3 bg-gold hover:bg-gold-400 text-navy-950 font-semibold px-10 py-5 text-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_40px_rgba(212,175,55,0.5)]"
          >
            Get Approved Now
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href="#products"
            data-testid="final-cta-secondary"
            className="inline-flex items-center gap-3 border border-white/30 hover:border-white text-white px-10 py-5 text-lg transition-all hover:bg-white/5"
          >
            See Your Options
          </a>
        </div>
      </div>
    </section>
  );
}
